import { Link, CircularProgress, Paper, RadioGroup, FormControlLabel, Radio, Button } from "@mui/material";
import { useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WarningIcon from '@mui/icons-material/Warning';

export function LinkNotAnalysed({ link, scrapReport, linksInStoryline, linksInStorylineReady, handleOpenClick }){
    return (
        <>
            { linksInStorylineReady?(linksInStoryline.includes(link)?<><WarningIcon/></>:(<></>)):(<CircularProgress size={20}/>) }
            <Link target="child" href={link} onClick={() => { handleOpenClick(link, scrapReport)}}>{ link }</Link>
            <Link href={ link } target="_blank"><OpenInNewIcon /></Link>
            <br/>
        </>
    )
}

export function LinkAnalysed({ linkAnalysed, scrapReport, linksInStoryline, linksInStorylineReady, handleOpenClick, loadList }){

    const [selectedTitle, setSelectedTitle] = useState("extracted");


    const title = linkAnalysed.isArticle? (selectedTitle == "extracted"?linkAnalysed.extractedTitle:linkAnalysed.proposedTitle): (
        linkAnalysed.jobTitle
    )

    function handleCreateClicked(){
        let storyElement = {
            title: title,
            link: linkAnalysed.link,
            description: linkAnalysed.summary?linkAnalysed.summary:"",
            type: linkAnalysed.isArticle?"News":(linkAnalysed.isJob?"Job":"Unknown"),
            timestampFormatted: new Date(scrapReport.timestamp).toISOString().substring(0, 10),
            timestamp: scrapReport.timestamp
        }

        console.log(storyElement);
        
        StorylineServerProxy.createStoryElement(storyElement).then(() => {
            if(scrapReport.analysisResult){
                if(scrapReport.analysisResult.length == 1){
                    if(window.confirm("Scrap report fully processed - Delete it?")){
                        StorylineServerProxy.markScrapReportAsDeleted(scrapReport._id)?.then(() => {
                            loadList();
                        })
                    }
                    else{
                        loadList();
                    }
                }
            }
            else{
                loadList();
            }
        })
    }


    return (
        <>
            { 
                linkAnalysed.isArticle?
                <Paper elevation={4} sx={{ padding:4}}>
                        <RadioGroup value={selectedTitle} onChange={target => { setSelectedTitle(target.currentTarget.value) }}>
                            <FormControlLabel value="extracted" control={<Radio />} label={ linkAnalysed.extractedTitle } />
                            <FormControlLabel value="proposed" control={<Radio />} label={ linkAnalysed.proposedTitle } />
                        </RadioGroup>
                        <br/>
                        { linkAnalysed.summary }
                        <br/>
                        <LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleOpenClick}/>
                        <br/>
                        <Button onClick={handleCreateClicked}>Create</Button>
                </Paper>
            :
            linkAnalysed.isJob?
            <Paper elevation={4} sx={{padding: 4}}>
                { linkAnalysed.jobTitle }
                <br/>
                <LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStoryline={linksInStoryline} linksInStorylineReady={linksInStorylineReady} handleOpenClick={handleOpenClick}/>
                <br/>
                <Button onClick={handleCreateClicked}>Create</Button>
            </Paper>
            :<LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleOpenClick}/> }
        </>
    )
}
